import { LitElement, html, css } from 'lit'

customElements.define('k-header-menu', class extends LitElement{

    static properties = {
        open: {type: Boolean, reflect: true}
    }

    static styles = css`
        :host {
            display: block;
            position:relative;
            color: var(--header-color);
        }

        k-logo {
            height: 4em;
            margin-bottom: 2em;
        }

        ul {
            list-style: none;
            margin: 0;
            display: flex;
            gap: 2em;
            margin: 0;
            padding: 0;
        }

        a, b-text {
            text-decoration: none;
            color: var(--header-color);
            font-family: var(--font-header);
        }

        .sub-menu {
            display: none;
        }

        .toggle { 
            display: none;
            padding: 1em;
            margin: -1em;
        }

        .current-menu-item > a {
            color: var(--blue);
        }

        k-logo {
            display: none;
        }

        @media (min-width: 800px) {
            
            a {
                position: relative;
                text-decoration: none;
            }

            a::before {
                background: var(--orange);
                content: "";
                inset: 0;
                position: absolute;
                transform: scaleX(0);
                transform-origin: right;
                transition: transform 0.15s ease-in-out;
                z-index: -1;
                clip-path: polygon(2% 0, 100% 0, 98% 100%, 0 100%);
                height: .25em;
                top: auto;
            }

            a:hover::before {
                transform: scaleX(1);
                transform-origin: left;
            }
        }

        @media (max-width: 799px) {

            .toggle.open {
                display: inline-block;
            }

            :host([open]) .toggle.open { display: none;}
            :host([open]) .toggle.close { 
                display: inline-block;
                position: absolute;
                top: 1.4em;
                right: 1.4em;
            }

            :host(:not([open])) ul { display: none; }

            :host([open]) {
                position: absolute;
                top: 0;
                left: 0;
                width: 100vw;
                height: 100vh;
                background-color: white;
                padding: 2em;
                color: inherit;
            }

            :host([open]) k-logo {
                display:inline-block;
            }

            a, b-text {
                color: inherit;
            }

            ul {
                display: grid;
                justify-items: center;
            }

            :host([open]) .sub-menu {
                display: grid;
            }

            .menu > li > a {
                font-size: 1.6em;
            }

            li > .sub-menu {
                margin-left: 1em;
                margin-top: 1em;
                gap: .5em;
            }
        }
    `

    constructor(){
        super()
        this.menu = siteMenus?.['header-menu'] || []
    }

    firstUpdated(){
        setTimeout(()=>{
            this.content = this.children[0].cloneNode(true)
            this.requestUpdate()

            // this.open = true // TEMP
        })
    }

    // menuFor(id=0){
    //     return this.menu.filter(d=>d.parent==id)
    // }

    toggleOpen(){
        this.open = !this.open
    }

    render(){return html`

        <b-text @click=${this.toggleOpen} class="toggle open">Menu</b-text>
        <b-text @click=${this.toggleOpen} class="toggle close">
            <svg width="24" height="24" viewBox="0 0 24 24">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
        </b-text>

        <k-logo h @click=${this.home}></k-logo>

        ${this.content}
    `}

    home(){
        window.location = '/'
    }

    // _render(){return html`
    //     ${this.renderMenu(this.menuFor(0))}
    // `}

    // renderMenu(menu, level=0){ return menu?.length ? html`
    //     <section level=${level}>
    //         ${menu.map(d=>html`
    //         <div>
    //             <b-text>${d.title}</b-text>
    //             ${this.renderMenu(this.menuFor(d.id), ++level)}
    //         </div>
    //         `)}
    //     </section>
    // ` : '' }

})

export default customElements.get('k-header-menu')